import { useEffect, useState } from "react";
import { BasicTable, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../../theme/Component/BasicTable";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _Product } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectTaxSchemeCatalogWithHoldingTax } from "./SelectTaxSchemeCatalogWithHoldingTax";


interface Props {
    idProduct: number;
    onChange: Function
}

export const TaxSchemeCatalogWithHoldingTax = ({ idProduct, onChange }: Props) => {

    const { lista, setLista, setBean, instance } = useDataBean(_Product);
    const [idTaxScheme, setIDTaxScheme] = useState<any>({});

    useEffect(() => {
        if (idProduct && idTaxScheme.IDTaxScheme)
            getLista()
    }, [idProduct, idTaxScheme])

    const getLista = () => {
        instance.getProductTaxSchemaValuesForHoldingValue(idTaxScheme.IDTaxScheme, idProduct).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDTaxSchemeValue', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo de Impuesto', property: 'TaxSchemeName', visible: true, },
        { title: 'Valor', property: 'TaxValueName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Tipo de valor', property: 'ValueTypeName', visible: true },
        { title: 'Tipo de Bien', property: 'AdquisitionArticleTypeName', visible: true },
        { title: 'Tipo de Contribuyente', property: 'TaxFilerTypeName', visible: false },
        { title: 'Cuenta Contable Retención/Descuento', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Contable Vr Agregado', property: 'AccountantIDAddedValueName', visible: false },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Códigos de Clasificación', property: 'TaxCodeList', visible: false, Style: { maxWidth: '100vh', wordWrap: 'break-word', whiteSpace: 'normal' } },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const setRowBean = (obj: any) => {
        setBean(obj)
        if (onChange) {
            onChange(obj);
        }
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <SelectTaxSchemeCatalogWithHoldingTax onChange={(e) => { setIDTaxScheme(e) }} label="Tipos de Impuestos" />
            </div>
            <div className="col-md-12">
                <BasicTable head={head} body={lista} rowSet={setRowBean} />
            </div>
        </div >
    )
}



